import { Link } from 'react-router-dom';
import { reviews } from '@/mocks/reviews';

const TestimonialsPreview = () => (
  <section className="py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <div className="text-center mb-12">
        <p className="text-amber-500 text-xs font-semibold uppercase tracking-widest mb-2">What Clients Say</p>
        <h2 className="text-4xl font-black text-stone-900">Loved by Thousands</h2>
        <div className="flex items-center justify-center gap-2 mt-3">
          <div className="flex">
            {[1,2,3,4,5].map(i => (
              <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
            ))}
          </div>
          <span className="text-stone-600 font-bold">4.9</span>
          <span className="text-stone-400 text-sm">based on 2,450+ reviews</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {reviews.slice(0, 3).map(review => (
          <div key={review.id} className="bg-stone-50 rounded-2xl p-6 border border-stone-100">
            <div className="flex items-center gap-1 mb-3">
              {[1,2,3,4,5].map(i => (
                <i key={i} className={`ri-star-fill text-sm ${i <= review.rating ? 'text-amber-400' : 'text-stone-200'}`}></i>
              ))}
            </div>
            <p className="text-stone-600 text-sm leading-relaxed mb-4 line-clamp-4">"{review.text}"</p>
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 rounded-full overflow-hidden bg-stone-200 flex-shrink-0">
                <img src={review.avatar} alt={review.reviewer} className="w-full h-full object-cover object-top" />
              </div>
              <div>
                <p className="font-semibold text-stone-800 text-sm">{review.reviewer}</p>
                <p className="text-stone-400 text-xs">{review.location}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <Link
          to="/contact"
          className="inline-flex items-center gap-2 px-8 py-3 border border-stone-200 text-stone-700 hover:border-amber-400 hover:text-amber-600 rounded-full text-sm font-semibold transition-colors cursor-pointer"
        >
          Read All Reviews
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </div>
  </section>
);

export default TestimonialsPreview;
